import { useState } from 'react';
import { MarkdownContent } from './MarkdownContent';

type MarkdownGuidanceDetailsProps = {
  title?: string;
  value?: string | null;
};

export function MarkdownGuidanceDetails({
  title = 'O que se espera',
  value,
}: MarkdownGuidanceDetailsProps) {
  const [open, setOpen] = useState(false);
  const markdown = value?.trim() ?? '';
  if (!markdown) {
    return null;
  }

  return (
    <div className="mt-1">
      <button
        type="button"
        className="text-xs font-medium text-primary-700 hover:underline"
        onClick={() => setOpen((current) => !current)}
      >
        {open ? 'Ocultar detalhe' : title}
      </button>
      {open ? (
        <div className="mt-2 rounded-lg border border-secondary-200 bg-secondary-50 p-3">
          <MarkdownContent value={markdown} />
        </div>
      ) : null}
    </div>
  );
}
